import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'lib-ksf-clauses-display',
    templateUrl: './ksf-clauses-display.component.html',
    styleUrls: ['./ksf-clauses-display.component.scss'],
    standalone: false
})
export class KsfClausesDisplayComponent {
  // Event emitted to the parent component
  @Output() nextStepEvent = new EventEmitter();

  // Input properties to receive data from the parent component
  @Input() ksfPriceResult: any; // make interface
  @Input() ksfPriceLoading: boolean = false;

  /**
   * Emits an event to proceed to the next step in the process after clauses have been accepted.
   * @returns void
   */
  acceptClauses(): void {
    this.nextStepEvent.emit();
  }
}
